module.exports = __webpack_public_path__ + "static/img/hos-hk.51f0746.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/hos-hk.jpg
// module id = hK57
// module chunks = 0